import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { ml } from 'src/_shared/services/utils.js';
import { formatJobLocation } from 'src/_shared/services/formatJobLocation.js';

export const JobLocation = ({
	allMultiLingualData = [],
	currentUser,
	location,
	locations = [],
}) => {
	if (!location) return null;
	const {
		city,
		state,
		country,
		isRemote,
		originalLocation,
		prefersOriginalLocation: prefersOriginalLocationRaw,
	} = location;

	const prefersOriginalLocation = prefersOriginalLocationRaw === 'true' || prefersOriginalLocationRaw === true;

	const remoteLabel = ml('Remote', currentUser, allMultiLingualData);

	const isVisible = [
		city,
		state,
		country,
		isRemote,
		originalLocation,
		prefersOriginalLocation,
	].some(Boolean);

	// Single source of truth (formatJobLocation): keeps country for international roles
	// (e.g. "Dublin, Ireland" instead of the old "Dublin, Dublin") and keys Remote off the flag.
	const formatLocation = (loc) => formatJobLocation(loc, remoteLabel);

	const locationText =
		locations.length > 1
			? ml('Multiple Locations', currentUser, allMultiLingualData)
			: formatJobLocation(location, remoteLabel);

	const tooltipContent = locations.length > 1 ? (
		<div>
			{locations.map((location, index) => (
				<div key={index} style={{ marginBottom: index < locations.length - 1 ? '4px' : '0' }}>
					{formatLocation(location)}
				</div>
			))}
		</div>
	) : null;

	return (
		<li>
			{isVisible && <i className="icon-location" />}
			{locations.length > 1 ? (
				<Tooltip title={tooltipContent} placement="bottom">
					<span>{locationText}</span>
				</Tooltip>
			) : (
				<span>{locationText}</span>
			)}
		</li>
	);
};

JobLocation.propTypes = {
	allMultiLingualData: PropTypes.arrayOf(PropTypes.object),
	currentUser: PropTypes.object.isRequired,
	location: PropTypes.shape({
		city: PropTypes.string,
		state: PropTypes.string,
		country: PropTypes.string,
		isRemote: PropTypes.bool,
		originalLocation: PropTypes.string,
		prefersOriginalLocation: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	}).isRequired,
	locations: PropTypes.arrayOf(PropTypes.object),
};